"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var FeCheckbox = function FeCheckbox(props) {
  /** Minimum condition required to render*/
  if (!(props.name && props.value)) {
    return null;
  }
  /** Rendering of component */


  var wrapperClass = (0, _classnames.default)('fe-checkbox', {
    'fe-checkbox--inline': props.isInline
  }, props.className);
  var id = props.id || "".concat(props.name, "-").concat(props.value);
  var checkboxProps = Object.assign({}, props);
  delete checkboxProps.label;
  delete checkboxProps.isInline;
  delete checkboxProps.className;
  return _react.default.createElement("div", {
    className: wrapperClass
  }, _react.default.createElement("label", {
    className: "fe-checkbox__label",
    htmlFor: id
  }, _react.default.createElement("input", _extends({}, checkboxProps, {
    id: id,
    type: "checkbox",
    className: "fe-checkbox__input"
  })), _react.default.createElement("span", {
    className: "fe-checkbox__checkbox"
  }, props.label && _react.default.createElement("span", {
    className: "fe-checkbox__text"
  }, props.label))));
};

FeCheckbox.defaultProps = {
  name: null,
  value: null,
  label: null,
  isInline: false
};
FeCheckbox.propTypes = {
  /** Provide group name for checkbox*/
  name: _propTypes.default.string.isRequired,

  /** Provide value for checkbox*/
  value: _propTypes.default.string.isRequired,

  /** Provide lable for checkbox*/
  label: _propTypes.default.string,

  /** Set true/false to change radio item alignment*/
  isInline: _propTypes.default.bool
};
FeCheckbox.displayName = 'FeCheckbox';
var _default = FeCheckbox;
exports.default = _default;